<template>
    <div>
      <div class="justify-center flex pb-5">
        <h4>Admin Login</h4>
      </div>
      <Form ref="formObserver" v-slot="{ handleSubmit, errors: formErrors }" @submit="handleSubmit(submitForm)">
        <d-message v-if="formErrors.generic || genericError" type="error" class="w-full mb-3">
          {{ formErrors.generic || genericError }}
        </d-message>

        <form ref="form" method="post" action="/account/login">
          <input type="hidden" name="ReturnUrl" :value="returnUrl">
          <Field name="email" :rules="{ required: true }" v-slot="{ field, errors }">
            <d-field label="Email" :errors="errors">
              <d-input v-bind="field" v-model="form.email" name="email" required />
            </d-field>
          </Field>
          <Field name="password" :rules="{ required: true }" v-slot="{ field, errors }">
            <d-field label="Password" :errors="errors">
              <d-input v-bind="field" v-model="form.password" name="password" required type="password" password-reveal />
            </d-field>
          </Field>
          <d-field label=" ">
            <input type="hidden" name="RememberMe" :value="form.rememberMe">
            <d-switch v-model="form.rememberMe">
              Remember Me
            </d-switch>
          </d-field>
          <div class="md:flex justify-between items-center mt-4 hidden">
            <a href="/forgotpassword/index" class="underline hover:no-underline">Forgot Password?</a>
            <d-btn type="submit" :loading="submitting">
              Log In
            </d-btn>
          </div>
          <div class="md:hidden pt-5">
            <d-btn color="secondary-500" type="submit" :loading="submitting" block>
              Log In
            </d-btn>
            <div class="text-center pt-4">
              <a href="/forgotpassword/index" class="underline hover:no-underline">Forgot Password?</a>
            </div>
          </div>
        </form>
      </Form>
  </div>
</template>

<script>
import localforage from '@resources/scripts/plugins/localstorage';
import { Form, Field } from 'vee-validate';
import { DotnetMixin } from '@mixins/index';

export default {
  name: 'LoginPage',
  
  components: {
    Form,
    Field,
  },

  mixins: [DotnetMixin],

  props: {
    returnUrl: String,
    pageErrors: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      submitting: false,
      genericError: '',
      form: {
        email: '',
        password: '',
        rememberMe: false,
        returnUrl: this.returnUrl,
      },
    };
  },

  mounted() {
    if (this.pageErrors.length > 0) {
      localforage.setItem('loginEmail', null);
      this.processOnRenderErrors(this.pageErrors);
    }
    localforage.getItem('loginEmail')
      .then((value) => {
        if (value) {
          this.form.email = value;
        }
      })
      .catch(() => {
        // Handle any localStorage errors silently
      });
  },

  methods: {
    submitForm() {
      this.submitting = true;
      localforage.setItem('loginEmail', this.form.email);
      this.$refs.form.submit();
    },
  },
};
</script>